var map = {
	"./1000_F_538018857_ojaHDFhOsxirc7AZBFrNjA6fjIWbwRSd-removebg-preview.png": 7497,
	"./3668b58e-26f4-4e05-9ecc-88ae22234d67.jpg": 3081,
	"./Homepage-removebg-preview.png": 251,
	"./Homepage.jpg": 2150,
	"./Kayachikitsa.jpg": 9738,
	"./Shalya Tantra.jpg": 4884,
	"./WhatsApp Image 2026-02-03 at 9.31.34 AM.jpeg": 7038,
	"./WhatsApp Image 2026-02-03 at 9.31.35 AM (1).jpeg": 2281,
	"./WhatsApp Image 2026-02-03 at 9.31.35 AM.jpeg": 3,
	"./WhatsApp Image 2026-02-03 at 9.31.36 AM (1).jpeg": 9238,
	"./WhatsApp Image 2026-02-03 at 9.31.36 AM (2).jpeg": 4321,
	"./WhatsApp Image 2026-02-03 at 9.31.36 AM.jpeg": 2284,
	"./WhatsApp Image 2026-02-03 at 9.31.37 AM (1).jpeg": 111,
	"./WhatsApp Image 2026-02-03 at 9.31.37 AM.jpeg": 7769,
	"./WhatsApp Image 2026-02-03 at 9.31.38 AM (1).jpeg": 6740,
	"./WhatsApp Image 2026-02-03 at 9.31.38 AM.jpeg": 586,
	"./WhatsApp Image 2026-02-03 at 9.31.39 AM (1).jpeg": 3557,
	"./WhatsApp Image 2026-02-03 at 9.31.39 AM.jpeg": 3839,
	"./WhatsApp Image 2026-02-03 at 9.31.40 AM.jpeg": 1747,
	"./WhatsApp Image 2026-02-03 at 9.31.41 AM (1).jpeg": 4344,
	"./WhatsApp Image 2026-02-03 at 9.31.41 AM (2).jpeg": 1639,
	"./WhatsApp Image 2026-02-03 at 9.31.41 AM.jpeg": 3614,
	"./WhatsApp Image 2026-02-03 at 9.31.42 AM (1).jpeg": 3727,
	"./WhatsApp Image 2026-02-03 at 9.31.42 AM.jpeg": 3641,
	"./WhatsApp Image 2026-02-03 at 9.31.43 AM (1).jpeg": 1574,
	"./WhatsApp Image 2026-02-03 at 9.31.43 AM.jpeg": 5356,
	"./WhatsApp Image 2026-02-03 at 9.31.44 AM (1).jpeg": 8941,
	"./WhatsApp Image 2026-02-03 at 9.31.44 AM.jpeg": 9351,
	"./WhatsApp Image 2026-02-03 at 9.31.45 AM (1).jpeg": 3388,
	"./WhatsApp Image 2026-02-03 at 9.31.45 AM (2).jpeg": 4987,
	"./WhatsApp Image 2026-02-03 at 9.31.45 AM.jpeg": 2722,
	"./WhatsApp Image 2026-02-03 at 9.31.46 AM (1).jpeg": 7491,
	"./WhatsApp Image 2026-02-03 at 9.31.46 AM.jpeg": 7629,
	"./WhatsApp Image 2026-02-03 at 9.31.47 AM.jpeg": 2608,
	"./WhatsApp Image 2026-02-03 at 9.31.48 AM (1).jpeg": 7105,
	"./WhatsApp Image 2026-02-03 at 9.31.48 AM (2).jpeg": 4566,
	"./WhatsApp Image 2026-02-03 at 9.31.48 AM.jpeg": 7835,
	"./WhatsApp Image 2026-02-03 at 9.31.49 AM (1).jpeg": 5392,
	"./WhatsApp Image 2026-02-03 at 9.31.49 AM.jpeg": 6630,
	"./WhatsApp Image 2026-02-03 at 9.36.36 AM.jpeg": 7777,
	"./WhatsApp Image 2026-02-04 at 2.20.10 AM.jpeg": 5728,
	"./WhatsApp Image 2026-02-06 at 5.27.25 PM.jpeg": 2621,
	"./WhatsApp Image 2026-02-06 at 5.27.27 PM.jpeg": 8327,
	"./WhatsApp Image 2026-02-06 at 5.27.28 PM (1).jpeg": 2238,
	"./WhatsApp Image 2026-02-06 at 5.27.28 PM.jpeg": 2900,
	"./WhatsApp Image 2026-02-06 at 5.27.29 PM.jpeg": 2609,
	"./WhatsApp Image 2026-02-06 at 5.27.30 PM (1).jpeg": 2137,
	"./WhatsApp Image 2026-02-06 at 5.27.30 PM.jpeg": 4867,
	"./WhatsApp Image 2026-02-06 at 5.27.31 PM.jpeg": 3694,
	"./WhatsApp Image 2026-02-06 at 5.27.32 PM (1).jpeg": 8543,
	"./WhatsApp Image 2026-02-06 at 5.27.32 PM.jpeg": 5193,
	"./WhatsApp Image 2026-02-06 at 5.27.33 PM.jpeg": 1884,
	"./WhatsApp Image 2026-02-06 at 5.27.34 PM (1).jpeg": 4429,
	"./WhatsApp Image 2026-02-06 at 5.27.34 PM.jpeg": 2599,
	"./WhatsApp Image 2026-02-06 at 5.27.35 PM (1).jpeg": 7644,
	"./WhatsApp Image 2026-02-06 at 5.27.35 PM.jpeg": 658,
	"./WhatsApp Image 2026-02-06 at 5.27.36 PM.jpeg": 1917,
	"./WhatsApp Image 2026-02-06 at 5.27.37 PM (1).jpeg": 7114,
	"./WhatsApp Image 2026-02-06 at 5.27.37 PM.jpeg": 752,
	"./WhatsApp Image 2026-02-06 at 5.27.38 PM.jpeg": 7755,
	"./WhatsApp Image 2026-02-06 at 5.27.39 PM (1).jpeg": 5760,
	"./WhatsApp Image 2026-02-06 at 5.27.39 PM.jpeg": 5526,
	"./WhatsApp Image 2026-02-06 at 5.27.40 PM.jpeg": 3282,
	"./WhatsApp Image 2026-02-07 at 3.30.36 PM (1).jpeg": 2298,
	"./WhatsApp Image 2026-02-07 at 3.30.36 PM (2).jpeg": 2261,
	"./WhatsApp Image 2026-02-07 at 3.30.36 PM.jpeg": 2704,
	"./WhatsApp Image 2026-02-07 at 3.30.37 PM (1).jpeg": 6739,
	"./WhatsApp Image 2026-02-07 at 3.30.37 PM.jpeg": 8045,
	"./WhatsApp Image 2026-02-07 at 3.30.38 PM (1).jpeg": 3264,
	"./WhatsApp Image 2026-02-07 at 3.30.38 PM.jpeg": 5574,
	"./WhatsApp Image 2026-02-07 at 3.30.39 PM (1).jpeg": 9377,
	"./WhatsApp Image 2026-02-07 at 3.30.39 PM.jpeg": 5979,
	"./WhatsApp Image 2026-02-07 at 3.30.40 PM (1).jpeg": 3309,
	"./WhatsApp Image 2026-02-07 at 3.30.40 PM.jpeg": 3047,
	"./WhatsApp Image 2026-02-07 at 3.30.41 PM (1).jpeg": 2876,
	"./WhatsApp Image 2026-02-07 at 3.30.41 PM (2).jpeg": 2283,
	"./WhatsApp Image 2026-02-07 at 3.30.41 PM.jpeg": 1106,
	"./WhatsApp Image 2026-02-07 at 3.30.42 PM (1).jpeg": 4019,
	"./WhatsApp Image 2026-02-07 at 3.30.42 PM.jpeg": 6013,
	"./WhatsApp Image 2026-02-07 at 3.30.43 PM (1).jpeg": 5994,
	"./WhatsApp Image 2026-02-07 at 3.30.43 PM (2).jpeg": 7717,
	"./WhatsApp Image 2026-02-07 at 3.30.43 PM.jpeg": 1200,
	"./WhatsApp Image 2026-02-07 at 3.30.44 PM (1).jpeg": 1017,
	"./WhatsApp Image 2026-02-07 at 3.30.44 PM.jpeg": 5315,
	"./WhatsApp Image 2026-02-16 at 2.42.59 AM (1).jpeg": 1060,
	"./WhatsApp Image 2026-02-16 at 2.42.59 AM.jpeg": 9898,
	"./ab.jpg": 5639,
	"./contact.jpg": 9200,
	"./download-removebg-preview.png": 7679,
	"./download.png": 4654,
	"./ee82e2471a176030a77142bd075a47e2.jpg": 7430,
	"./growth-close-up-environmental-lush-natural_1172-349.jpg": 7363,
	"./growth-close-up-environmental-lush-natural_1172-349.png": 7627,
	"./herbal life.jpg": 5464,
	"./lang.png": 5426,
	"./leaf.jpg": 7258,
	"./leaf.png": 7998,
	"./logo.jpeg": 6184,
	"./personal care.jpg": 5035,
	"./png1.jpg": 6904,
	"./png2.jpg": 711,
	"./pr1.jpg": 3115,
	"./pr2.jpg": 6668,
	"./pr3.jpg": 4457,
	"./pro.jpg": 6445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5935;